export default () => {
  Alpine.bind('verificationCodeInput', (props = {}) => ({
    'x-data': () => ({
      length: props.length,
      fieldName: props.fieldName,
      fieldValue: '',
      
      handleInput(e) {
        const input = e.target;
        
        this.fieldValue = Array.from(Array(this.length), (element, i) => {
          return this.$refs[i].value || "";
        }).join("");
        
        if (input.nextElementSibling && input.value) {
            input.nextElementSibling.focus();
            input.nextElementSibling.select();
        }
      },
      
      handleBackspace(e, index) {
        if (e.target.value) {
          return;
        }
        
        const previous = index > 0 ? index - 1 : 0;
        this.$refs[previous] && this.$refs[previous].focus();
      },
      
      handlePaste(e) {
        const pasteData = e.clipboardData.getData('text');
        this.fieldValue = pasteData.slice(0, this.length);
        
        const inputs = Array.from(Array(this.length));
        inputs.forEach((element, i) => {
          this.$refs[i].value = this.fieldValue[i] || ''
        });
        this.$refs[this.fieldValue.length - 1].focus()
      },
    
      input: (index) => ({
        '@input.prevent': 'handleInput',
        ['@keydown.backspace'](e) {
          this.handleBackspace(e, index);
        },
        '@paste': 'handlePaste',
        'autocomplete': 'off',
        'x-ref': index,
        'maxlength': 1,
        'type': 'text'
      })
    }),
  }))
}
